import { getStore } from '../store/childStore';
import { mutatorAction } from 'satcheljs';
import { PopoutChildState } from '../store/schema/PopoutChildStore';

export default mutatorAction('setPopoutChildState', (state: PopoutChildState) => {
    getStore().state = state;
});
